export default function Container({ children }) {
  return (
    <div style={{ paddingLeft: '2rem', paddingRight: '2rem' }}>{children}</div>
  )
}
